var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8408 3.58674L16.3159 0H10.684L10.061 4.25767L9.97229 4.86424C10.1304 4.96037 10.3178 5.01681 10.5194 5.01681C11.006 5.01681 11.4118 4.69177 11.513 4.25767H11.5252C11.6264 4.69177 12.0321 5.01681 12.5187 5.01681C12.9997 5.01681 13.4018 4.69925 13.5088 4.2727C13.6158 4.69925 14.0179 5.01681 14.4988 5.01681C14.981 5.01681 15.3839 4.69781 15.4897 4.26976C15.5955 4.69781 15.9984 5.01681 16.4805 5.01681C16.6821 5.01681 16.8695 4.96036 17.0277 4.86424L16.8408 3.58674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.30518C6.04416 5.30518 0 11.0572 0 18.1526C0 25.248 6.04416 31 13.5 31C20.9559 31 27 25.248 27 18.1526C27 11.0572 20.9558 5.30518 13.5 5.30518ZM16.5051 21.0376L15.587 22.0421C15.5295 22.1121 15.4722 22.1823 15.4163 22.2539C14.5825 23.3205 13.9161 24.5529 13.4181 25.9539C12.8348 24.1022 11.855 22.5011 10.4567 21.1541C9.05818 19.8059 7.40477 18.8645 5.47708 18.3134C7.06813 17.7783 8.44689 17.0461 9.61766 16.1161C10.0845 15.7262 10.8357 15.0163 11.7904 13.8306C12.525 12.8131 13.1153 11.6548 13.5611 10.3518C14.1341 12.2413 15.1071 13.866 16.5115 15.2347C16.8561 15.5711 17.2179 15.8794 17.594 16.1651C17.7868 16.2928 18.7857 16.9515 19.2538 17.2036C19.966 17.5743 20.7234 17.8754 21.5263 18.1073C19.5231 18.7662 17.8514 19.7411 16.5051 21.0376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSidebar);
export default __webpack_public_path__ + "static/media/calendar-sidebar.f38f87b7a36cdb27ebaa1c158d9f6e3c.svg";
export { ForwardRef as ReactComponent };